module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isActive) ? _c('div', {
    staticClass: "zoom-separated zoom-component"
  }, [_c('div', {
    staticClass: "mouse-tracker",
    on: {
      "mousemove": function($event) {
        $event.stopPropagation();
        _vm.setZoomEvent(true, $event)
      },
      "mouseleave": function($event) {
        $event.stopPropagation();
        _vm.setZoomEvent(false)
      },
      "click": _vm.onClick
    }
  }), (_vm.event) ? _c('div', {
    staticClass: "zoom-lens",
    style: ({
      left: _vm.event.position.x + 'px',
      top: _vm.event.position.y + 'px',
      width: _vm.event.size + 'px',
      height: _vm.event.size + 'px'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "zoom-overlay",
    style: (_vm.zoomStyle)
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81381844!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/tooltip/ZoomSeparated.vue
// module id = 364
// module chunks = 1